<template>
<CContainer>
	<CRow>
		<CCol col="12" class="px-0">
            <CreateBtn class="mfe-2" @click="modal = {item: {}, show: true}" />
		</CCol>

		<CCol col="12" class="px-0 mt-2">
			<CRow>
				<CCol col="12" md="3" v-for="(group, index) in groups" :key="index">
					<CCard class="hover-it">
						<CCardBody class="mx-auto">
							<span class="d-block text-center">{{ group.name }}</span>
							<CLink :to="{name: 'publishers.list', params: {store_id: group.store_id}, query: {group_id: group.id}}">مشاهده بازاریابان</CLink>

							<CLink class="edit-it px-1" @click="modal = {item: Object.assign({}, group), show: true}">
								<FaIcon icon="edit" />
							</CLink>
							<CLink class="remove-it px-1" @click="deleteModal = {item: Object.assign({}, group), show: true}">
								<FaIcon icon="trash" class="text-danger" />
							</CLink>
						</CCardBody>
					</CCard>
				</CCol>
			</CRow>
		</CCol>
	</CRow>

	<CModal :title="$t('v2commission.group.delete')" color="danger" :show.sync="deleteModal.show">
		{{ $t('v2commission.group.are_you_sure_to_remove', { attribute: deleteModal.item.name }) }}
		<template #footer>
			<CButton @click="deleteModal.show = false" color="secondary">
				{{ $t('cancel') }}
			</CButton>
			<CButton @click="deleteGroup" color="danger">
				{{ $t('delete') }}
			</CButton>
		</template>
	</CModal>
	<CModal color="primary" :show.sync="modal.show">
		<template #header-wrapper>
			<span></span>
		</template>

		<GroupForm v-if="modal.item.id === undefined" @onSubmit="editOrCreateGroup" ref="groupForm" />
		<GroupForm v-else :group="modal.item" @onSubmit="editOrCreateGroup" ref="groupForm" />

		<template #footer-wrapper>
			<span></span>
		</template>
	</CModal>
</CContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GroupForm } from './partials/groups'
import { CommissionModel, CommissionType } from '@/constants'
import { filterObject } from '@/common/objects'

export default {
	name: 'Group',

	components: {
		GroupForm
	},

	data() {
		return {
			storeId: this.$route.params.store_id,
			modal: {
				show: false,
				item: {}
			},
			deleteModal: {
				show: false,
				item: {}
			},
			commission: {}
		}
	},

	computed: {
		...mapGetters({
			commissions: 'v2commission/commissions',
		}),
		groups() {
			return this.commission = filterObject(
				this.commissions,
				commission => commission.model === CommissionModel.GROUP
			)
		}
	},

	methods: {
		...mapActions({
			create: 'v2commission/create',
			edit: 'v2commission/edit',
			delete: 'v2commission/delete',
			setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
		}),
		editOrCreateGroup(group) {
			this.setShowLoading()
            this.resetMsg()

			const data = {
				id: group.id || undefined,
				name: group.name,
				sale: group.sale,
				lead: group.lead,
				model: group.model || CommissionModel.GROUP,
				type: CommissionType.MIX,
				store_id: group.store_id || this.storeId
			}
			const form = data.id ? this.edit(data) : this.create(data)

			form
				.then(res => {
					this.setShowLoading(false)
					this.modal.show = false
					this.$refs.groupForm.$refs.form.reset()
				}).catch(result => {
					if(result.data) {
						this.$refs.groupForm.$refs.form.setErrors(result.data)
					}
					this.setShowLoading(false)
					this.setMsg({
						content: this.$t('tags.'+result.tag),
						type: 'danger'
					})
				})
		},
		deleteGroup() {
			this.delete(this.deleteModal.item.id).then(res => {
				this.deleteModal.show = false
			})
		},
	}
}
</script>

<style lang="scss" scoped>
::v-deep {
    .hover-it {
        transition: all .2s;

        a.edit-it,
        a.remove-it {
            position: absolute;
            opacity: 0;
            transition: all .5s;
        }

        a.edit-it {
            left: 30px;
            top: 5px;
        }

        a.remove-it {
            left: 10px;
            top: 5px;
        }

        &:hover {
            a.edit-it,
            a.remove-it {
                opacity: 1;
            }
            box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, .08) !important;
        }
    }
}
</style>